var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrnMapHelpResearcher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "16px",
    viewBox: "0 0 63 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BRN---Mapping-the-Network---Instructions",
    transform: "translate(-477.000000, -470.000000)",
    fill: "#FFC92C",
    stroke: "#000000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.239294,472.269078 C496.888735,471.414799 508.267958,471.279012 517.707899,471.835949 C523.924487,472.202715 528.859679,472.547416 532.513449,472.870384 C533.956864,472.997971 535.261139,473.614487 536.255372,474.557786 C537.249605,475.501085 537.933796,476.771167 538.137044,478.205885 C538.288154,479.272562 537.992602,480.299506 537.392603,481.097558 C536.792605,481.895611 535.888159,482.464771 534.821483,482.615881 C517.965858,483.316567 506.317636,483.877646 499.487087,484.334035 C494.590384,484.661213 489.942575,484.505074 485.543817,483.862253 C483.879728,483.619058 482.401,482.832244 481.289277,481.688654 C480.177556,480.545067 479.432837,479.044706 479.236759,477.374414 C479.088523,476.111659 479.466153,474.908366 480.19653,473.983701 C480.919997,473.067784 481.98957,472.42525 483.239294,472.269078 Z",
    id: "Rectangle"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrnMapHelpResearcher);
export default __webpack_public_path__ + "static/media/BRN-Map-Help-Researcher.0632628d2155a6acdb66c30e58fb882b.svg";
export { ForwardRef as ReactComponent };